export const paths = {
    bffBngApi: '/mein-kundencenter/bng/api',
    bffHotportApi: '/hotport/api',
    bffDevApi: '/eafn/api',
}
